import { useOptionalTourContext } from "../../contexts/TourContext";
import CaseListTourRunner from "./CaseListTourRunner";

// No provider means the list is rendering outside the layout shell, which gets
// no tour
const CaseListTour = ({ isReady }) => {
   const hasTourProvider = Boolean(useOptionalTourContext());

   return hasTourProvider ? <CaseListTourRunner isReady={isReady} /> : null;
};

export default CaseListTour;
